const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');

/**
 * Defines the add cohort manager component
 */
app.directive('addCohortManager', [function () {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      workshop: '=?',
      saveInstances: '&?',
      saveCohort: '&?',
      publishedMessage: '&?',
      cohortInstances: '=?',
      publishedCohorts: '=?',
      createWorkshop: '&?'
    },
    template: require('../../../templates/directives/cms/add-cohort-manager.html'),
    controller: ['$scope', function ($scope) {
      var self = this;

      self.info = {
        showNameCreate: false,
        editing: false,
        newName: '',
        activeCohort: {},
        loading: true
      };


      self.state = {
        inEdit: function(cohort) {
          if (self.info.editing && self.info.activeCohort.id === cohort.id) {
            return true;
          }
          return false;
        },
        saving: false
      };

      self.actions = {
        startAddNew: function() {
          if (!$scope.workshop.id) {
            $scope.createWorkshop();
          }
          self.info.showNameCreate = true;
        },
        openEdit: function (cohort) {
          self.info.newName = cohort.name;
          self.info.activeCohort = cohort;
          self.info.editing = true;
        },
        saveEdit: function() {
          self.state.saving = true;
          var toEdit = $scope.workshop.cohorts.find(function(cohort) {
            return cohort.id === self.info.activeCohort.id;
          })
          toEdit.name = self.info.newName;
          $scope.saveCohort();
          self.actions.reset();
        },
        addNew: async function() {
          var newCohort = {
            name: self.info.newName,
            instanceIds: []
          }
          $scope.workshop.cohorts.push(newCohort);
          self.actions.reset();
          const id = await $scope.saveCohort();
          if (id && id !== null) {
            self.saved[id] = true;
            self.activeTitle[id] = true; 
            $scope.$apply();
          }
        },
        reset: function() {
          self.info.showNameCreate = false;
          self.info.newName = '';
          self.info.activeCohort = '';
          self.info.editing = false;
        },
        remove: function(cohort) {
          for (let i = 0; i < $scope.workshop.cohorts.length; i++) {
            if (cohort.id && $scope.workshop.cohorts[i].id === cohort.id) {
              $scope.workshop.cohorts.splice(i, 1);
            }
          }
          $scope.saveCohort();
        }
      };

      self.mapSessionsToInstanceDates = function() {
        const sessionsWithInstanceDates = {};
        $scope.workshop.sessions.forEach(session => {
          sessionsWithInstanceDates[session.id] = session.instances.map(instance => { return {name: moment(instance.start).format('dddd, MMMM D, YYYY (h:mma z)'), value: instance.id}; });
        });
        return sessionsWithInstanceDates;
      };

      self.saved = {};

      self.trackSaved = function(cohortId) {
        self.saved[cohortId] = false;
      };

      self.mapToSaved = function() {
        $scope.workshop.cohorts.forEach(cohort => {
          self.saved[cohort.id] = true;
        });
      };

      self.activeTitle = {};

      self.mapToClosedDropdown = function(newCohort) {
        $scope.workshop.cohorts.forEach(cohort => {
          self.activeTitle[cohort.id] = false;
        });
      };

      self.init = function() {
        self.sessionsWithInstanceDates = self.mapSessionsToInstanceDates();
        self.mapToSaved();
        self.mapToClosedDropdown();
        self.info.loading = false;
      };

      self.init();
    }],
    controllerAs: 'addCohort'
  };
}]);